export enum FDC3_INSTRUMENT_ID_TYPE {
  FDS_TYPE = 'FDS_TYPE',
  FDS_ID = 'FDS_ID',
  FDS_INPUT_ID = 'FDS_INPUT_ID',
  CUSIP = 'CUSIP',
}

export enum FDC3_BONDS_TYPE {
  FIXED_INCOME = 'fixedIncome',
  DEBT = 'debt',
  CORPORATE_DEBT = 'corporateDebt',
  GOVERNMENT_BENCHMARK_DEBT = 'governmentBenchmarkDebt',
  MUNICIPAL_DEBT = 'municipalDebt',
  SOVEREIGN_DEBT = 'sovereignDebt',
}

export enum FDC3_FUNDS_TYPE {
  MUTUAL_FUND = 'mutualFund',
  ETF = 'etf',
}

export enum FDC3_EQUITY_TYPE {
  PUBLIC_COMPANY = 'publicCompany',
}

export enum FDC3_CASH_TYPE {
  UNKNOWN = 'unknown',
}
